export let authorityConstant;

if (document.location.origin === 'https://dojo.objectively.win') {
  authorityConstant = 'login.objectively.win';
} else if (
  [
    'http://localhost:8081',
    'https://cerebral3.azurewebsites.net',
    'https://cerebral2.azurewebsites.net',
    'https://cerebral2-east.azurewebsites.net',
    'https://cerebral1.azurewebsites.net',
    'https://cerebral1-east.azurewebsites.net',
  ].includes(document.location.origin)
) {
  authorityConstant = 'persuastionstudiesb2c.b2clogin.com';
} else if (document.location.origin === 'https://dojo.objectively.ai') {
  authorityConstant = 'login.objectively.ai';
}
